import React from 'react';

import {Container, Title, Subtitle} from './styles';

interface ITitles {
  title: string;
  subtitle?: string;
}

export function Titles({title, subtitle}: ITitles) {
  return (
    <Container>
      <Title>{title}</Title>

      {subtitle ? <Subtitle>{subtitle}</Subtitle> : <></>}
    </Container>
  );
}
